import { render, staticRenderFns } from "./TopRankings.vue?vue&type=template&id=26559d30&scoped=true"
import script from "./TopRankings.vue?vue&type=script&lang=js"
export * from "./TopRankings.vue?vue&type=script&lang=js"
import style0 from "./TopRankings.vue?vue&type=style&index=0&id=26559d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26559d30",
  null
  
)

export default component.exports